// extracted by mini-css-extract-plugin
module.exports = {"image":"HeycarImage_image__iE6UM","container":"HeycarImage_container__qN3Kb","isStandAlone":"HeycarImage_isStandAlone__myFW_"};